import Moveable from "moveable"

let moveable;

export default function MapAdjust(vm, google, bounds, map, options = {}) {

  gm.prototype = new google.maps.OverlayView();
  function gm(vm, bounds, map, options) {
    this.vm = vm;
    this.bounds = bounds;
    this.map = map;
    this.angle = options.angle;
    this.image = options.floorFile;
    this.div = null;
    this.opacity = options.floorOpacity;
    this.setMap(map);
  }

  gm.prototype.onAdd = function () {

    const div = document.createElement('div');
    div.id = 'socanRegtange';
    div.style.borderColor = 'rgba(0, 168, 255)';
    div.style.borderStyle = 'solid';
    div.style.borderWidth = '2px';
    div.style.position = 'absolute';
    div.style.background = 'rgba(0, 168, 255, 0.1)';

    div.style.transform = 'rotate(' + this.angle + 'deg)';

    if (this.image !== '') {
      const img = document.createElement('img');
      img.id = 'floorMapImg';
      img.src = this.image;
      img.style.opacity = '0.5';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.opacity = this.opacity / 100;
      img.style.position = 'absolute';
      div.appendChild(img);
    }

    this.div = div;

    const panes = this.getPanes();
    panes.overlayMouseTarget.appendChild(div);
    panes.markerLayer.id = 'socanLayer';

    const dropMoveable = (el, drag) => {
      let top;
      let left;

      top = parseFloat(window.getComputedStyle(el).top);
      left = parseFloat(window.getComputedStyle(el).left);
      const width = parseFloat(window.getComputedStyle(el).width);
      const height = parseFloat(window.getComputedStyle(el).height);

      const newSW = {
        x: left,
        y: height + top
      };

      const newNE = {
        x: width + left,
        y: top
      };

      const newLatSw = this.getProjection().fromDivPixelToLatLng(newSW).lat();
      const newLngSw = this.getProjection().fromDivPixelToLatLng(newSW).lng();

      const newLatNe = this.getProjection().fromDivPixelToLatLng(newNE).lat();
      const newLngNe = this.getProjection().fromDivPixelToLatLng(newNE).lng();

      const newAngle = parseFloat(getCurrentRotation(el));

      this.vm.setDataFromAdjustMap({
        'floor_sw_lat': newLatSw,
        'floor_sw_lon': newLngSw,
        'floor_ne_lat': newLatNe,
        'floor_ne_lon': newLngNe,
        'floor_angle': newAngle,
        'floor_map_zoom': map.zoom,
      });

      this.bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(newLatSw, newLngSw),
        new google.maps.LatLng(newLatNe, newLngNe)
      );
    }

    const renderTransform = (target) => {
      const { translate, rotate } = frame;
      target.style.transform = `translate(${translate[0]}px, ${translate[1]}px) rotate(${rotate}deg)`;
    }

    let rotate = this.angle;

    moveable = new Moveable(document.querySelector("#adjustMap"), {
      target: document.querySelector("#socanRegtange"),
      draggable: true,
      rotatable: true,
      resizable: true,
      scalable: false,
      warpable: false,
      origin: false,
      keepRatio: false,
      edge: false,
      throttleDrag: 0,
      throttleResize: 0,
      throttleScale: 0,
      throttleRotate: 0,
    });

    const frame = {
      translate: [0, 0],
      rotate: rotate,
    };

    moveable.on("dragStart", ({ inputEvent }) => {
      inputEvent.stopPropagation();
    });

    moveable.on("drag", ({
      target, transform,
      left, top, right, bottom,
      beforeDelta, beforeDist, delta, dist,
      clientX, clientY,
    }) => {
      target.style.left = `${left}px`
      target.style.top = `${top}px`
      dropMoveable(target, null)
    });

    moveable.on("rotateStart", ({ set }) => {
      set(frame.rotate);
    }).on("rotate", ({ target, beforeRotate }) => {
      frame.rotate = beforeRotate;
      renderTransform(target)
      dropMoveable(target, null)
    });

    moveable.on("resizeStart", ({ target, set, setOrigin, dragStart }) => {
      setOrigin(["%", "%"])
      const style = window.getComputedStyle(target)
      const cssWidth = parseFloat(style.width)
      const cssHeight = parseFloat(style.height)
      set([cssWidth, cssHeight])
      dragStart && dragStart.set(frame.translate);
    }).on("resize", ({ target, width, height, drag }) => {
      target.style.width = width + "px"
      target.style.height = height + "px"
      target.style.left = `${drag.left}px`
      target.style.top = `${drag.top}px`
      // frame.translate = drag.beforeTranslate
      renderTransform(target)
      dropMoveable(target, drag)
    });
  }

  gm.prototype.draw = function () {
    const overlayProjection = this.getProjection();
    const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest());
    const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast());
    const div = this.div;
    if (!div) {
      return;
    }

    div.style.left = sw.x + 'px';
    div.style.top = ne.y + 'px';
    div.style.width = (ne.x - sw.x) + 'px';
    div.style.height = (sw.y - ne.y) + 'px';

    moveable.updateRect();
  }

  gm.prototype.onRemove = function () {
    this.div.parentNode.innerHTML = '';
    this.div = null;
    moveable.updateRect();
  }

  function getCurrentRotation(el) {
    const st = window.getComputedStyle(el, null)
    const tm = st.getPropertyValue("-webkit-transform") ||
      st.getPropertyValue("-moz-transform") ||
      st.getPropertyValue("-ms-transform") ||
      st.getPropertyValue("-o-transform") ||
      st.getPropertyValue("transform") ||
      "none";
    if (tm != "none") {
      const values = tm.split('(')[1].split(')')[0].split(',');
      const angle = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI));

      return (angle < 0 ? angle + 360 : angle);
    }
    return 0;
  }

  return new gm(vm, bounds, map, options);
}
